// extracted by mini-css-extract-plugin
module.exports = {"title":"ParserRulesCreate_title__1LGMg"};